import request from "~/utils/http";

const branchApi = {
	gets : async (params) => {
		const url = 'v1/branch';
		return await request.get(url, {params});
	},
	getById : async (id) => {
		const url = `v1/branch/${id}`;
		return await request.get(url);
	},
	add : async (params) => {
		const url = 'v1/branch';
		return await request.post(url, params);
	},
	update : async (params) => {
		const url = `v1/branch/${params.id}`;
		return await request.post(url, params);
	},
	delete : async (id) => {
		const url = `v1/branch/${id}`;
		return await request.delete(url);
	},
	default : async (id) => {
		const url = `v1/branch/default/${id}`;
		return await request.post(url);
	},
};

export default branchApi;